import Link from 'next/link';
import Session from '@/components/Session';
import logoMin from '@/assets/images/logo.min.png';
import Icon_facebook from '@/assets/images/icon_facebook.svg';
import Icon_instagram from '@/assets/images/icon_instagram.svg';
import logoTripGroup from '@/assets/images/logo.tripgroup.fff.png';
import tripLogo from '@/assets/logo/trip.fff.png';
import skyscannerLogo from '@/assets/logo/skyscanner.fff.png';
import ctripLogo from '@/assets/logo/ctrip.fff.png';

export default function Footer() {
    return (
        <>
            <Session className='footer'>
                <div className='footer-main'>
                    <div className='footer-content'>
                        <div className='footer-logo'>
                            <Link href='/'>
                                <img
                                    className='footer-logo-img'
                                    src={logoMin.src}
                                />
                            </Link>
                            <div className='footer-subtitle'>Long Stay Made Easy.</div>
                        </div>
                        <div className='footer-group'>
                            <div className='title'>A brand-new program of</div>
                            <div className='pic'>
                                <img src={logoTripGroup.src} />
                            </div>
                        </div>
                        <div className='footer-desc'>
                            Easytrip is Trip.com Group's brand-new program, which caters to the surging demand for long stay accommodation worldwide. At
                            Easytrip, our mission is to provide unparalleled long stay experience for global travelers. Be it extended stay hotels or serviced
                            apartments, you can always find the ideal place to stay longer.
                        </div>
                        <div className='footer-social-links'>
                            <Link
                                href='https://www.facebook.com/tripcom.sg/?locale=en-SG&curr=AED'
                                target='_blank'
                                rel='”nofollow”'
                            >
                                <img src={Icon_facebook.src} />
                            </Link>
                            <Link
                                href='https://www.instagram.com/trip.com_sg/?locale=en-SG&curr=AED'
                                target='_blank'
                                rel='”nofollow”'
                            >
                                <img src={Icon_instagram.src} />
                            </Link>
                        </div>
                    </div>

                    <div className='footer-links'>
                        <div className='links-column'>
                            <div className='link-title'>
                                <span className='name'>Trip.com Group</span>
                                <img
                                    src={logoTripGroup.src}
                                    className='pic'
                                />
                            </div>
                            <Link
                                className='link pic'
                                href='https://hk.trip.com/?locale=en_hk&allianceid=3316851&sid=14848606'
                                target='_blank'
                            >
                                <img src={tripLogo.src} />
                            </Link>
                            <Link
                                className='link pic'
                                href='https://www.skyscanner.com.hk/hotels?locale=en-GB'
                                target='_blank'
                            >
                                <img src={skyscannerLogo.src} />
                            </Link>
                            <Link
                                className='link pic'
                                href='https://www.ctrip.com/?allianceid=3316851&sid=14848606'
                                target='_blank'
                            >
                                <img src={ctripLogo.src} />
                            </Link>
                        </div>
                        <div className='links-column'>
                            <div className='link-title'>About</div>
                            <Link
                                className='link'
                                href='https://group.trip.com/?locale=en-US&allianceid=3316851&sid=14848606'
                                target='_blank'
                            >
                                About Trip.com Group
                            </Link>
                            <Link
                                className='link'
                                href='https://sg.trip.com/pages/customer-service/?locale=en_sg&allianceid=3316851&sid=14848606'
                                target='_blank'
                            >
                                Service Guarantee
                            </Link>
                            <Link
                                className='link'
                                href='https://pages.trip.com/service-guideline/privacy-policy-en-sg.html?allianceid=3316851&sid=14848606'
                                target='_blank'
                            >
                                Privacy Policy
                            </Link>
                        </div>
                    </div>
                </div>

                <div className='footer-copyright'>
                    <p>
                        Copyright © 2023 Ctrip.com (Hong Kong) Limited. All rights reserved.
                        <br />
                        Site Operator: Ctrip.com (Hong Kong) Limited.
                    </p>
                </div>
            </Session>
        </>
    );
}
